<template>
  <div class="overview-card">
    <div class="card-header">
      <i :class="['status-icon', isActive ? 'operational' : 'inactive']"></i>
      <h4>{{ depotName }}</h4>
    </div>
    <div class="card-content">
      <p class="card-count">Vehicles Assigned: {{ vehicles.length }}</p>
      <ul class="vehicle-list">
        <li v-for="vehicle in vehicles" :key="vehicle.id" @click="$emit('selectVehicle', vehicle)">
          <span class="vehicle-plate">{{ vehicle.plate }}</span>
          <span class="status-badge" :class="getStatusClass(vehicle.status)">
            {{ getStatusShortText(vehicle.status) }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepotCard',
  props: {
    depotName: { type: String, required: true },
    vehicles: { type: Array, required: true },
    isActive: { type: Boolean, default: true }
  },
  methods: {
    getStatusClass(status) {
      const cls = `status-${status || 'operational'}`;
      return cls;
    },
    getStatusShortText(status) {
      const map = {
        'operational': 'Active',
        'on-duty': 'On Duty',
        'maintenance': 'Maint.',
        'inactive': 'Inactive'
      };
      return map[status] || 'Active';
    }
  }
}
</script>

<style scoped>
.overview-card {
  flex: 1 1 30%;
  min-width: 250px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
  border: 1px solid #e6e6e6;
  transition: transform 0.2s, box-shadow 0.2s;
}
.overview-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eaeaea;
}
.card-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(78, 205, 196, 0.1);
  color: #4ecdc4;
  font-size: 1.2rem;
}
.card-content {
  padding: 15px;
}
.card-count {
  margin: 0 0 12px;
  font-size: 0.95rem;
  color: #6c757d;
}
.vehicle-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 150px;
  overflow-y: auto;
  border-radius: 4px;
}
.vehicle-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 5px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  font-size: 0.9rem;
}
.vehicle-list li:hover {
  background-color: #f8f9fa;
}
.vehicle-list li:last-child {
  border-bottom: none;
}
.status-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
}
.status-operational { background-color: rgba(76, 175, 80, 0.15); color: #4caf50; }
.status-on-duty { background-color: rgba(33, 150, 243, 0.15); color: #2196f3; }
.status-maintenance { background-color: rgba(255, 152, 0, 0.15); color: #ff9800; }
.status-inactive { background-color: rgba(244, 67, 54, 0.15); color: #f44336; }
.status-icon {
  font-style: normal;
  font-weight: bold;
  margin-right: 2px;
  font-size: 3rem;    /* increased size for larger dot */
}
.status-icon.operational::before {
  content: "●";
  color: #4caf50;
}
.status-icon.inactive::before {
  content: "●";
  color: #f44336;
}
</style>
